import { useMediaQuery } from "react-responsive";

const SM_WIDTH = 576; //, MD_WIDTH = 768, LG_WIDTH = 992, XL_WIDTH = 1200;

// reactive version (hook)
export const useIsMobile = (width = SM_WIDTH) => useMediaQuery({ query: `(max-width: ${width}px)` });

// non reactive version (for non-react components)
export const isMobile = () => window.innerWidth <= SM_WIDTH;

export default useIsMobile;
